/* unplugin-vue-components disabled */import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-nft-image.vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "token-box"
};
const _hoisted_2 = {
  class: "index"
};
const _hoisted_3 = {
  class: "index-title"
};
const _hoisted_4 = {
  key: 0,
  class: "index-subtitle"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "OpenSea", -1);

const _hoisted_8 = ["href"];
const _hoisted_9 = ["src"];
import { getChainName, getChainNameByChainId, getChainScanNameByChainId } from '@/service/chains-config';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-collection',
  props: {
    collection: null,
    type: {
      default: 'index'
    }
  },

  setup(__props) {
    const props = __props;
    const isDark = useDark();
    const chainName = computed(() => {
      return getChainName(getChainNameByChainId(props.collection.chainId));
    });
    const nft = reactive({
      openseaUrl: '',
      browserUrl: ''
    });
    onBeforeMount(() => {
      const {
        openseaUrl,
        browserUrl
      } = props.collection;

      if (openseaUrl) {
        nft.openseaUrl = openseaUrl;
      }

      if (browserUrl) {
        nft.browserUrl = browserUrl;
      }
    });

    const getOpenseaUrl = openseaUrl => {
      nft.openseaUrl = openseaUrl;
    };

    return (_ctx, _cache) => {
      const _component_up_nft_image = __unplugin_components_0;

      const _component_up_icon = __unplugin_components_1;

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["up-collection", props.type])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_up_nft_image, {
        "image-url": props.collection.imageUrl,
        "chain-id": props.collection.chainId,
        "contract-address": props.collection.contractAddress,
        onOpenseaUrl: getOpenseaUrl
      }, null, 8, ["image-url", "chain-id", "contract-address"]), _createVNode(_component_up_icon, {
        class: "box-chain",
        name: _unref(chainName)
      }, null, 8, ["name"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(props.collection.name), 1), nft.openseaUrl || nft.browserUrl ? (_openBlock(), _createElementBlock("div", _hoisted_4, [nft.openseaUrl ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: nft.openseaUrl,
        target: "_blank"
      }, [_createElementVNode("img", {
        src: _unref(isDark) ? require('@/assets/img/nft/opensea-dark.png') : require('@/assets/img/nft/opensea-light.png'),
        alt: "openSea"
      }, null, 8, _hoisted_6), _hoisted_7], 8, _hoisted_5)) : _createCommentVNode("", true), nft.browserUrl ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: nft.browserUrl,
        target: "_blank"
      }, [_createElementVNode("img", {
        src: require(`@/assets/img/nft/${_unref(getChainScanNameByChainId)(props.collection.chainId)}.svg`)
      }, null, 8, _hoisted_9), _createElementVNode("span", null, _toDisplayString(_unref(getChainScanNameByChainId)(props.collection.chainId)), 1)], 8, _hoisted_8)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 2);
    };
  }

});